import { Pipe, PipeTransform } from '@angular/core';
import striptags from 'striptags';

const allowedTags = ['br'];

@Pipe({ name: 'striptags' })
export class StriptagsPipe implements PipeTransform {
  public transform(value: any, allowed?: string[]) {
    if (!value) {
      return '';
    }
    if (typeof value !== 'string') {
      return value;
    }
    return striptags(value, allowed || allowedTags);
  }
}
